enum ReportType {
  OPTAIN = 'optain',
  CLINICAL = 'clinical',
  PATIENT = 'patient',
}

const ReportTypeName = (type: ReportType): string => {
  switch (type) {
    case ReportType.CLINICAL: {
      return 'Clinical Report';
    }
    case ReportType.PATIENT: {
      return 'Patient Report';
    }
    case ReportType.OPTAIN: {
      return 'Report';
    }
    default: {
      return `Unknown: ${type}`;
    }
  }
};

export { ReportType, ReportTypeName };
